import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ADDRESS_1_ERROR,
  ADDRESS_2_ERROR,
  ADDRESS_3_ERROR,
  EMAIL_ERROR,
  NAME_ERROR,
  PHONE_ERROR, POSTAL_CODE_ERROR,
  REQUIRED_ERROR,
  EMAIL_MATCH_ERROR
} from 'src/app/validators.constants';
import {
  emailValidatorList,
  firstNameValidatorList,
  lastNameValidatorList,
  phoneFirstValidatorList,
  phoneSecondValidatorList,
  phoneThirdValidatorList,
  postalCodeFirstValidatorList,
  postalCodeSecondValidatorList,
  addressFirstValidatorList,
  addressSecondValidatorList,
  addressThirdValidatorList
} from 'src/app/validators';
import { slideY } from 'src/app/animations';
import { createSecondFieldValidator } from 'src/app/validators.functions';
import Regions from 'src/app/data/regions';
import Subscriber from 'src/app/subscriber';
import { isEqual } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { IFormCustomerInfoData } from './form-customer-info.interfaces';
import { MediaService } from 'app/services/media.service';

@Component({
  selector: 'app-form-customer-info',
  templateUrl: './form-customer-info.component.html',
  styleUrls: ['./form-customer-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideY()],
})
export class FormCustomerInfoComponent implements OnInit, OnDestroy {
  @Input() headerTitle = 'お客さま情報';

  @Input() headerTitleContent?: string;

  /** `undefined` when invalid */
  @Input() set data(data: IFormCustomerInfoData | undefined) {
    if (!isEqual(data, this.data)) {
      this._dataSubject.next(data);
      this.dataChange.emit(data);

      if (data && !isEqual(data, this.formGroup.value)) {
        this.formGroup.setValue(data);
      }
    }
  }

  get data(): IFormCustomerInfoData | undefined {
    return this._dataSubject.value;
  }

  private _dataSubject = new BehaviorSubject<IFormCustomerInfoData | undefined>(undefined);

  @Output() dataChange = new EventEmitter<IFormCustomerInfoData | undefined>();

  private _touchEventEmitterSub = new Subscriber();

  @Input() set touchEventEmitter(e: EventEmitter<void> | undefined) {
    this._touchEventEmitterSub.unsubscribe(); // unsubscribe from previous sub`s

    if (!e) return;

    this._touchEventEmitterSub.push( // add new subscription
      e.subscribe(() => {
        this.formGroup.markAllAsTouched();
        this._cdr.detectChanges(); // detect changes to redraw the component
      }),
    );
  }

  public formGroup = new FormGroup({
    // name
    lastName: new FormControl('', lastNameValidatorList),
    firstName: new FormControl('', firstNameValidatorList),
    // postal code
    postalCodeFirst: new FormControl('', postalCodeFirstValidatorList),
    postalCodeSecond: new FormControl('', postalCodeSecondValidatorList),
    // address
    addressFirst: new FormControl('', addressFirstValidatorList),
    addressSecond: new FormControl('', addressSecondValidatorList),
    addressThird: new FormControl('', addressThirdValidatorList),
    // phone
    phoneFirst: new FormControl('', phoneFirstValidatorList),
    phoneSecond: new FormControl('', phoneSecondValidatorList),
    phoneThird: new FormControl('', phoneThirdValidatorList),
    // email
    email: new FormControl('', emailValidatorList),
    email2: new FormControl('', [createSecondFieldValidator('email')]),
    emailReceive: new FormControl(true),
  });

  public readonly NAME_ERROR = NAME_ERROR;

  public readonly ADDRESS_1_ERROR = ADDRESS_1_ERROR;

  public readonly ADDRESS_2_ERROR = ADDRESS_2_ERROR;

  public readonly ADDRESS_3_ERROR = ADDRESS_3_ERROR;

  public readonly EMAIL_ERROR = EMAIL_ERROR;

  public readonly EMAIL_MATCH_ERROR = EMAIL_MATCH_ERROR;

  public readonly REQUIRED_ERROR = REQUIRED_ERROR;

  public readonly POSTAL_CODE_ERROR = POSTAL_CODE_ERROR;

  public readonly PHONE_ERROR = PHONE_ERROR;

  public readonly regions = Regions;

  private readonly _sub = new Subscriber();

  constructor(
    public media: MediaService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this._sub.push(
      this.formGroup.valueChanges.subscribe((data: IFormCustomerInfoData): void => {
        if (this.formGroup.valid) {
          this.data = data;
        } else {
          this.data = undefined;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }
}
